import { Theme } from '@mui/material';

/**
 * Background for toolbar strips and subtle surfaces: light gray in light mode,
 * elevated paper in dark mode.
 */
export function getSubtleSurfaceBackground(theme: Theme): string {
  return theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.palette.grey[50];
}
